<template>
  <div class="entrance">
    <div class="bac"></div>
    <div class="content">
      <login></login>
    </div>
  </div>
</template>

<script>
  import Login from '@/views/Login.vue';

  export default {
    name: 'Entrance',
    components: {
      Login
    }
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .entrance {
    height: 100%;
    background-color: @color-primary;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .bac {
      .setImg('/entrance/bac.png');
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
    .content {
      background-color: @color-white;
      width: 820px;
      height: 472px;
      border-radius: 12px;
      position: relative;
      z-index: 1;
      & > * {
        height: 100%;
      }
    }
  }
</style>